import React, { Component } from 'react';
import { Table } from 'reactstrap';
import axiosInstance from '@src/axios-instance';
import NameInput from './NameInput';

class EOIPricing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      entities: [],
      loading: false,
      entityId: null,
      inputClass: ''
    };
  }

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  componentDidMount = () => {
    this.getList({ sort: this.state.sort, direction: this.state.direction });
  };

  getList = getData => {
    axiosInstance()
      .get('/evidence-of-insurance-pricings.json', { params: getData })
      .then(response => {
        this.setState({
          loaded: true,
          loading: false,
          entities: response.data.list,
          sort: response.data.sort,
          direction: response.data.direction,
          entityId: null
        });
      });
  };

  saveInput = (name, value, entityId) => {
    if (value.length < 1) {
      return false;
    }

    axiosInstance()
      .put(`/evidence-of-insurance-pricings/${entityId}.json`, {
        [name]: value
      })
      .then(response => {
        this.setState({
          active: false,
          activeCognitoDescription: false,
          activeDescription: false,
          activeRate: false,
          inputClass: '',
          entities: response.data.entities
        });
      })
      .catch(err => {});
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.loaded && (
          <div>
            <Table className={'mt-3'} hover={true}>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Cognito Forms Description</th>
                  <th>Description</th>
                  <th>Rate</th>
                  <th>Default</th>
                </tr>
              </thead>
              <tbody>
                {this.state.entities.map(item => {
                  return (
                    <tr key={`pricings-${item.id}`}>
                      <td className={'px-0'}>
                        <NameInput
                          value={item.item_name}
                          active={this.state.active === item.id}
                          inputClass={
                            this.state.active === item.id
                              ? this.state.inputClass
                              : ''
                          }
                          activeName={'active'}
                          size={'220px'}
                          entityId={item.id}
                          setState={props => this.setState(props)}
                          onBlur={e =>
                            this.saveInput(
                              'item_name',
                              e.currentTarget.value,
                              item.id
                            )
                          }
                        />
                      </td>
                      <td className={'px-0'}>
                        <NameInput
                          value={item.cognito_description}
                          active={
                            this.state.activeCognitoDescription === item.id
                          }
                          activeName={'activeCognitoDescription'}
                          size={'260px'}
                          inputClass={
                            this.state.activeCognitoDescription === item.id
                              ? this.state.inputClass
                              : ''
                          }
                          entityId={item.id}
                          setState={props => this.setState(props)}
                          onBlur={e =>
                            this.saveInput(
                              'cognito_description',
                              e.currentTarget.value,
                              item.id
                            )
                          }
                        />
                      </td>
                      <td className={'px-0'}>
                        <NameInput
                          value={item.description}
                          active={this.state.activeDescription === item.id}
                          activeName={'activeDescription'}
                          size={'250px'}
                          inputClass={
                            this.state.activeDescription === item.id
                              ? this.state.inputClass
                              : ''
                          }
                          entityId={item.id}
                          setState={props => this.setState(props)}
                          onBlur={e =>
                            this.saveInput(
                              'description',
                              e.currentTarget.value,
                              item.id
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          defaultValue={item.rate}
                          type={'number'}
                          className={'form-control form-control-sm'}
                          style={
                            this.state.activeRate === item.id
                              ? { width: '95px' }
                              : {
                                  borderColor: 'transparent',
                                  backgroundColor: 'transparent',
                                  width: '95px'
                                }
                          }
                          readOnly={this.state.activeRate !== item.id}
                          onClick={() => {
                            this.setState({
                              activeRate: item.id
                            });
                          }}
                          onChange={e => {
                            this.setState({
                              activeRate: item.id,
                              inputClass:
                                e.currentTarget.value.length > 0
                                  ? 'is-valid'
                                  : 'is-invalid'
                            });
                          }}
                          onBlur={e => {
                            let value = parseFloat(e.currentTarget.value);
                            this.saveInput('rate', value.toFixed(2), item.id);
                            e.currentTarget.value = value.toFixed(2);
                          }}
                        />
                      </td>
                      <td>
                        <input
                          type={'checkbox'}
                          onChange={e => {
                            this.saveInput('is_default', 1, item.id);
                          }}
                          checked={item.is_default === 1}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )}
      </React.Fragment>
    );
  };
}
export default EOIPricing;
